if (!customElements.get('cart-addon-product-options')) {
  customElements.define(
    'cart-addon-product-options',
    class CartAddonProductOptions extends HTMLElement {
      connectedCallback() {
        this.productRoot = this.closest('.cart-addon--product');
        this.form = this.closest('form');
        this.variantSelect = this.querySelector('[data-addon-variant]');
        this.sellingPlanSelect = this.querySelector('[data-addon-selling-plan]');

        this.variantSelect?.addEventListener('change', () => this.onVariantChange());
        this.sellingPlanSelect?.addEventListener('change', () => this.onSellingPlanChange());

        if (this.sellingPlanSelect) {
          this.updatePrice(this.sellingPlanSelect.selectedOptions[0]);
        }
      }

      onVariantChange() {
        this.updateVariantInput();
        this.updatePrice(this.variantSelect?.selectedOptions[0]);
        this.updateSubmitButton(this.isSelectedAvailable());
      }

      onSellingPlanChange() {
        this.updatePrice(this.sellingPlanSelect?.selectedOptions[0]);
      }

      updateVariantInput() {
        const variantInput = this.form?.querySelector('[name="id"]');
        if (!variantInput || !this.variantSelect) return;

        variantInput.value = this.variantSelect.value;
        variantInput.disabled = !this.isSelectedAvailable();
      }

      updatePrice(option) {
        if (!option || !this.productRoot) return;

        const priceContainer = this.productRoot.querySelector('[data-addon-price]');
        if (!priceContainer) return;

        const currentEl = priceContainer.querySelector('[data-addon-price-current]');
        const compareEl = priceContainer.querySelector('[data-addon-price-compare]');
        const badgeEl = priceContainer.querySelector('[data-addon-price-badge]');

        if (currentEl) currentEl.textContent = option.dataset.price || '';

        const compareAt = option.dataset.compareAtPrice;
        const discount = option.dataset.discountPercent;

        if (compareEl) {
          if (compareAt) {
            compareEl.textContent = compareAt;
            compareEl.classList.remove('hidden');
          } else {
            compareEl.classList.add('hidden');
          }
        }

        if (badgeEl) {
          if (discount) {
            badgeEl.textContent = `-${discount}%`;
            badgeEl.classList.remove('hidden');
          } else {
            badgeEl.classList.add('hidden');
          }
        }
      }

      updateSubmitButton(available) {
        const productForm = this.closest('product-form');
        if (!productForm?.toggleSubmitButton) return;

        if (available) {
          productForm.toggleSubmitButton(false);
        } else {
          productForm.toggleSubmitButton(true, window.variantStrings?.soldOut);
        }
      }

      isSelectedAvailable() {
        const option = this.variantSelect?.selectedOptions[0];
        return option?.dataset.available === 'true';
      }

      get selectedVariantId() {
        return this.variantSelect?.value ?? this.form?.querySelector('[name="id"]')?.value ?? '';
      }
    }
  );
}
